import { Component, OnInit, ViewChild } from '@angular/core';
import {
  HelperService,
  AppSettings,
  AuthenticationService,
  Agents,
} from '../../../services/_services';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import Swal from 'sweetalert2';

declare var document, $;

@Component({
  selector: 'app-closed-orders',
  templateUrl: './closed-orders.component.html',
  styleUrls: ['./closed-orders.component.css'],
})
export class ClosedOrdersComponent implements OnInit {
  public orderStatus: any = AppSettings.orderStatus;
  public despositionArray: any = AppSettings.disposition;
  public documentTypeArray: any = AppSettings.documentType;
  public siteAbbr: any = AppSettings.siteAbbr;
  public loading: any = false;
  public paginatePage: any;
  public leads: any = [];
  public comments: any = [];
  public agentComments: any = [];
  public qaComments: any = [];
  public agentsSub: any;
  public agents: any;
  public qa: any;
  public loader: any;
  public qaLoader: any;
  public qaRating: any;
  public notes: any = '';
  public addNoteIndex: any;
  public validInvalidArr: any = [
    { name: 'In-valid Sales', value: 0 },
    { name: 'Valid Sales', value: 1 },
  ];

  public veriUnveriArr: any = [
    { name: 'Unverified Sales', value: 0 },
    { name: 'Verified Sales', value: 1 },
  ];

  public orderTypesArray: any = [
    { name: 'All Closed', value: 'all' },
    { name: 'My Closed Leads', value: 'lead' },
    { name: 'My Closed Unpaid', value: 'unpaid' },
    { name: 'My Closed CWHP', value: 'cwhp' },
    { name: 'Closed with Half Payment', value: 'half' },
  ];

  public addCommentForm: FormGroup;
  public submitted: any = false;

  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;
  public dtOptions: DataTables.Settings = {};
  public dtTrigger: any = new Subject();

  public searchParams: any = {
    agent_id: [],
    emailId: '',
    valid_sales: null,
    verified_sales: null,
    is_paid: null,
    date_from: '',
    date_to: '',
    order_type: this.orderTypesArray[0].value,
  };
  public fullRangeDate: string[] = this.getDateRange();
  private getDateRange(): string[] {
    // Get current date/time in America/Los_Angeles
    const nowInLA = new Date(
      new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' })
    );
    console.log('Los Angeles current time:', nowInLA);
    // Set time to 00:00:00 for consistency (optional)
    nowInLA.setHours(0, 0, 0, 0);

    const formatDate = (date: Date): string => {
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const year = date.getFullYear();
      return `${month}-${day}-${year}`;
    };

    // Return the same date twice (start and end)
    return [formatDate(nowInLA), formatDate(nowInLA)];
  }

  public selectedDesposition: any;

  constructor(
    private helperService: HelperService,
    private agentsService: Agents,
    private formBuilder: FormBuilder
  ) {
    // this.activeUser = this.authenticationService.get_currentUserValue();

    // Get Agents

    this.agentsSub = this.agentsService.agentsS$.subscribe((agents) => {
      if (agents) {
        this.agents = agents.agents; // Store all agent IDs in this.agent_ids array
        // this.agent_ids = this.agents.map(agent => agent.id);
        this.agents.unshift({ name: 'Select All', id: 'all' });
        this.qa = agents.qa;
      }
    });

    this.dtOptions = {
      paging: true,
      info: true,
      // ordering: false,
      pagingType: 'full_numbers',
      pageLength: 10,
      serverSide: true,
      processing: true,
      searching: false,
      language: AppSettings.dataTableLang,
      columnDefs: [
        { orderable: true, targets: 0 },
        { orderable: false, targets: 1 },
        { orderable: false, targets: 2 },
        { orderable: false, targets: 3 },
        { orderable: false, targets: 4 },
        { orderable: false, targets: 5 },
        { orderable: false, targets: 6 },
        { orderable: false, targets: 7 },
        { orderable: false, targets: 8 },
        { orderable: false, targets: 9 },
      ],
      order: [[0, 'desc']],
      ajax: (dataTablesParameters: any, callback) => {
        // Show Loader
        this.loading = true;
        // console.log("dataTablesParameters", dataTablesParameters);

        let url = AppSettings.API_ENDPOINT + 'admin/closed-orders';

        let dtParams = {
          lead: this.searchParams.emailId,
          valid_sales: this.searchParams.valid_sales,
          verified_sales: this.searchParams.verified_sales,
          agent_id: this.searchParams.agent_id,
          order_type: this.searchParams.order_type,
          date_from: this.searchParams.date_from
            ? this.helperService.caonvertDateToString(
                this.searchParams.date_from
              )
            : this.fullRangeDate
            ? this.helperService.caonvertDateToString(this.fullRangeDate[0])
            : '',
          date_to: this.searchParams.date_to
            ? this.helperService.caonvertDateToString(
                this.searchParams.date_to,
                false
              )
            : this.fullRangeDate
            ? this.helperService.caonvertDateToString(
                this.fullRangeDate[1],
                false
              )
            : '',
          start: dataTablesParameters.start,
          length: dataTablesParameters.length,
          order: dataTablesParameters.order,
          columns: dataTablesParameters.columns,
        };

        // For Record Serial Numbers
        this.paginatePage = dataTablesParameters.start;

        // Empty Data
        this.leads = [];

        this.helperService
          .httpPostRequestsDecryp(url, dtParams)
          .then((resp) => {
            this.leads = JSON.parse(resp);
            // console.log("this.leads: ", this.leads);

            // Set Default page len
            this.dtOptions.pageLength = this.dtElement['dt'].page.len();

            // Hide Loader
            this.loading = false;

            callback({
              recordsTotal: this.leads.total,
              recordsFiltered: this.leads.total,
              // recordsFiltered: resp['recordsFiltered'],
              // recordsFiltered: 1000,
              data: [],
            });

            // // $(".paginate_button .current").css("color", "white");
            // // console.log('$(".paginate_button .current"): ',$(".paginate_button .current"))
            $('div.dataTables_length select').addClass('dt-form-control');
            $('div.dataTables_filter input').addClass('dt-form-control');
          })
          .catch((error) => {
            // Set loader false
            this.loading = false;

            // // Rerender DT in case of failure
            // this.rerender();

            console.log('error: ', error);
          });
      },
      columns: [
        // { data: 'multiDelete' },
        { data: 'id' },
        { data: 'date' },
        { data: 'phoneEmail' },
        { data: 'price_noOfPages' },
        { data: 'academic_level' },
        { data: 'document_type' },
        { data: 'due_date' },
        { data: 'disposition' },
        { data: 'assigned' },
        { data: 'comments' },
      ],
      // Use this attribute to enable the responsive extension
      responsive: false,
    };
  }

  ngOnInit() {
    this.addCommentForm = this.formBuilder.group({
      comment: [null, Validators.required],
    });
  }

  ngAfterViewInit() {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();

    if (typeof this.agentsSub != 'undefined') {
      //prevent memory leak when component destroyed
      this.agentsSub.unsubscribe();
    }
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();

      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

  splitFromTo() {
    if (this.fullRangeDate) {
      this.searchParams.date_from = this.fullRangeDate[0];
      this.searchParams.date_to = this.fullRangeDate[1];
    }

    this.rerender();
  }

  showComments(lead, index, type) {
    // Show Loader
    if (type == 'Closed-Agent-Comments') {
      this.leads.data[index].loadingComs = true;
    } else if (type == 'QA-Comments') {
      this.leads.data[index].loadingQACom = true;
    }

    let url = AppSettings.API_ENDPOINT + 'shared/get-comments';
    let data = { o: lead.id, type: type };

    this.helperService
      .httpPostRequests(url, data)
      .then((resp) => {
        if (typeof resp != 'undefined') {
          // console.log("resp", resp);
          this.comments = resp.data;
          this.agentComments = [];
          this.qaComments = [];

          for (let i = 0; i < this.comments.length; i++) {
            if (this.comments[i].type == 'Closed-Agent-Comments') {
              this.agentComments.push(this.comments[i]);
            } else if (this.comments[i].type == 'QA-Comments') {
              if (
                typeof this.comments[i].notes.split('<strong>')[1] !=
                'undefined'
              )
                this.comments[i]['qaRating'] = parseFloat(
                  this.comments[i].notes
                    .split('<strong>')[1]
                    .split('</strong>')[0]
                );

              this.qaComments.push(this.comments[i]);
              this.qaRating = lead.rating;
            }
          }

          // Agent can add new comments
          if (type == 'Closed-Agent-Comments') {
            this.notes = '';
            this.submitted = false;
            $('#comment_modal' + index).modal('show');
            $('.modal-backdrop').click(function () {
              $('#comment_modal' + index).modal('hide');
            });
          }

          if (this.qaComments.length > 0 && type == 'QA-Comments') {
            $('#qaFeedBack_modal' + index).modal('show');
            $('.modal-backdrop').click(function () {
              $('#qaFeedBack_modal' + index).modal('hide');
            });
          }
        }

        // Hide Loader
        this.leads.data[index].loadingQACom = false;
        this.leads.data[index].loadingComs = false;
      })
      .catch((err) => {
        // Hide Loader
        this.leads.data[index].loadingQACom = false;
        this.leads.data[index].loadingComs = false;
      });
  }

  get f() {
    return this.addCommentForm.controls;
  }

  addNotes(lead, index) {
    // Set Submission True
    this.submitted = true;

    // Stop here if form is invalid
    if (this.addCommentForm.invalid) {
      return;
    }

    this.loading = true;

    let url = AppSettings.API_ENDPOINT + 'shared/insert-note';
    let data = { id: lead.id, note: this.notes, type: 'Closed-Agent-Comments' };
    this.helperService
      .httpPostRequests(url, data)
      .then((resp) => {
        if (typeof resp != 'undefined') {
          Swal.fire('', resp.message, 'success');
        }

        // Hide Modal
        $('#comment_modal' + index).modal('hide');
        $('.modal-backdrop').remove();

        // Hide Loader
        this.loading = false;

        // this.rerender();
      })
      .catch((err) => {
        Swal.fire('', 'Something went wrong. Please try again', 'error');

        // Hide Loader
        this.loading = false;
      });
  }

  agentSearch(id, agentArr) {
    for (var i = 0; i < agentArr.length; i++) {
      if (agentArr[i].id === id) {
        return agentArr[i].name;
      }
    }
  }
  totalPaymentSearch(id, despoArr) {
    for (var i = 0; i < despoArr.length; i++) {
      if (despoArr[i].value === id) {
        return despoArr[i].name;
      }
    }
  }

  parseFloat(value) {
    return parseFloat(value);
  }

  clearFilters() {
    this.fullRangeDate = null;
    this.searchParams = {
      emailId: '',
      valid_sales: null,
      verified_sales: null,
      is_paid: null,
      date_from: '',
      date_to: '',
      order_type: this.orderTypesArray[0].value,
    };

    this.rerender();
  }

  selectAll() {
    if (this.searchParams.agent_id.includes('all')) {
      // If "Select All" is checked, select all agent IDs except 'all'
      this.searchParams.agent_id = this.agents
        .filter((agent) => agent.id !== 'all')
        .map((agent) => agent.id);
    } else if (this.searchParams.agent_id.length === 0) {
      // If no agent is selected, re-add "Select All"
      this.searchParams.agent_id = ['all'];
    }
    this.rerender();
  }
}
